import gql from 'graphql-tag';

export const linkMockExamStudent = gql`
  mutation linkMockExamStudent(
    $roundCode: ID!
    $locationCode: ID!
    $studentData: MockExamStudentProfileLinkInput!
  ) {
    linkMockExamStudent(
      roundCode: $roundCode
      locationCode: $locationCode
      studentData: $studentData
    ) {
      success
      error
      code
      message
      studentProfile {
        locationCode
        roundCode
        firstName
        lastName
        ssid
        phone
        email
        locationName
        studentCode
      }
    }
  }
`;
